export default __webpack_public_path__ + "static/media/img_1.fb6ff841.jpg";